import { IconChevronDown } from "@tabler/icons-react";
import React from "react";
import { useParams } from "react-router-dom";

const ActionsCellChevron = ({ row, handleRowClick }) => {
  const { contactListId } = useParams();
  const listId = parseInt(contactListId);

  return (
    <IconChevronDown
      size={24}
      className="bump"
      opacity={listId === row.id ? 1 : 0.4}
      style={{
        transform: listId === row.id ? "rotate(-90deg)" : "none",
        transition: "all ease .3s",
      }}
      onClick={() => handleRowClick({ row })}
    />
  );
};

export default ActionsCellChevron;
